// extracted by mini-css-extract-plugin
export var button = "_bs-0";
export var icon = "_bs-1";